'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-counter',
    cnDisabled = "".concat(CLASSNAME, "--disabled"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnInput = "".concat(CLASSNAME, "__input"),
    cnIconWrapper = "".concat(CLASSNAME, "__iconWrapper"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnIconLeft = "".concat(CLASSNAME, "__icon-left"),
    cnIconRight = "".concat(CLASSNAME, "__icon-right");
/**
 * 
 * @param {*} props 
 */

function Counter(_ref) {
  var disabled = _ref.disabled,
      max = _ref.max,
      min = _ref.min,
      name = _ref.name,
      onChange = _ref.onChange,
      required = _ref.required,
      title = _ref.title,
      value = _ref.value;

  var _useState = React.useState(parseInt(value !== null && value !== void 0 ? value : 1)),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  function handlePlusClick() {
    setCount(count + 1);
    onChange(count + 1);
  }

  function handleMinusClick() {
    setCount(count - 1);
    onChange(count - 1);
  }

  return /*#__PURE__*/React__default.createElement("label", {
    className: CLASSNAME
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnTitle, _rollupPluginBabelHelpers.defineProperty({}, cnDisabled, disabled))
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnWrapper, _rollupPluginBabelHelpers.defineProperty({}, cnDisabled, disabled))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnIconWrapper, cnIconLeft, _rollupPluginBabelHelpers.defineProperty({}, cnDisabled, count === min || disabled)),
    onClick: function onClick() {
      if (count > min & !disabled) {
        handleMinusClick();
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "minus",
    size: "xs",
    className: cnIcon
  })), /*#__PURE__*/React__default.createElement("div", {
    className: cnLabel
  }, /*#__PURE__*/React__default.createElement("input", {
    required: required,
    disabled: disabled,
    className: cnInput,
    type: "text",
    name: name,
    value: value
  }), count), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnIconWrapper, cnIconRight, _rollupPluginBabelHelpers.defineProperty({}, cnDisabled, count === max || disabled)),
    onClick: function onClick() {
      if (count < max && !disabled) {
        handlePlusClick();
      }
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "plus",
    size: "xs",
    className: cnIcon
  }))));
}
Counter.propTypes = {
  /** True if counter is disabled */
  disabled: PropTypes.bool,

  /** Maximum at which no more increase possible */
  max: PropTypes.number,

  /** Minimum at which no more decrease possible */
  min: PropTypes.number,

  /** Name in form */
  name: PropTypes.string,

  /** Callback function on change */
  onChange: PropTypes.func,

  /** True if is required in form */
  required: PropTypes.bool,

  /** Name of counter */
  title: PropTypes.string
};
Counter.defaultProps = {
  max: 1000,
  min: 0
};

module.exports = Counter;
